export const OurMediaProductionCardData = [
  {
    icon: "ic:baseline-photo-camera",
    title: "PHOTOGRAPHY",
    titleAR: "التصوير الفوتوغرافي",
    disc: "We capture moments that speak for your brand. From product shoots and portraits to lifestyle and event photography every shot is crafted with lighting, composition, and storytelling in mind.",
    discAR: "نلتقط لحظات تعبّر عن هوية علامتك التجارية. من تصوير المنتجات والبورتريه إلى التصوير الحي وأنماط الحياة، نصمم كل لقطة بعناية في الإضاءة والتكوين وسرد القصة.",
    link: "/photography-page",
  },

  {
    icon: "flowbite:video-camera-outline",
    title: "VIDEOGRPHY",
    titleAR: "تصوير الفيديو",
    disc: "Whether it’s a branded video, commercial, or behind-the-scenes content we film with purpose. High-quality visuals, smooth movement, and clear messaging that brings your story to life.",
    discAR: "سواء كان فيديو دعائي، إعلان تجاري، أو محتوى خلف الكواليس، نصور بهدف واضح ورسالة مؤثرة. صور عالية الجودة، حركة سلسة، ورسائل بصرية تعكس قصتك بوضوح.",
    link: "/videography-page",
  },
  {
    icon: "flowbite:video-camera-outline",
    title: "POST PRODUCTION",
    titleAR: "مرحلة ما بعد الانتاج",
    disc: "The magic happens in the edit. We handle video editing, color correction, motion graphics, sound design, and final exports making sure your content is polished, sharp, and ready to perform.",
    discAR: "السحر يبدأ من غرفة المونتاج. نحن نتولى المونتاج، تصحيح الألوان، الرسوم المتحركة، تصميم الصوت، وإخراج النسخ النهائية، لنضمن أن يكون محتواك متقنًا وجاهزًا للعرض بأعلى جودة.",
    link: "/post-production-page",
  },
  {
    icon: "tabler:aerial-lift",
    title: "Renting company studios",
    titleAR: "تأجير استوديوهات الشركة",
    disc: "Need a space to shoot? Our fully equipped studios are available for rent featuring professional lighting, backdrops, green screens, podcast setups, and all the technical support you need.",
    discAR: "تبحث عن مساحة للتصوير؟ نقدم استوديوهات مجهزة بالكامل للإيجار، تشمل إضاءة احترافية، خلفيات متنوعة، شاشات خضراء، تجهيزات للبودكاست، بالإضافة إلى الدعم الفني الكامل الذي تحتاجه.",
    link:'/renting-studio-page'
  },

];
